var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPageLeft(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 21,
    viewBox: "0 0 23 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h23v21H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#333",
    d: "M11.735 5.354a.5.5 0 1 0-.707-.708l-5.382 5.382a.5.5 0 0 0 0 .707l5.382 5.38a.5.5 0 0 0 .707-.706L6.707 10.38l5.028-5.027z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#333",
    d: "M15.735 5.354a.5.5 0 0 0-.707-.708l-5.382 5.382a.5.5 0 0 0 0 .707l5.382 5.38a.5.5 0 0 0 .707-.706l-5.028-5.028 5.028-5.027z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPageLeft);
export default __webpack_public_path__ + "static/media/page-left.7df2144af7e68549abba764f34b61df9.svg";
export { ForwardRef as ReactComponent };